import { Request } from 'fetchboi'

export const getInscriptions = Request.register({
    endpoint: '/inscriptions',
    method: 'get',
    useAuthentication: true
})

export const getInscriptionsByCourses = Request.register({
    endpoint: '/inscriptions/byCourseId/:courseId',
    method: 'get',
    useAuthentication: true
})

export const getInscriptionByCourse = Request.register({
    endpoint: '/inscriptions/byUserId/:userId?courseId=:courseId',
    method: 'get',
    useAuthentication: true
})

export const getCertificate = Request.register({
    endpoint: '/inscriptions/:id/certificate',
    method: 'get',
    useAuthentication: true
})

export const getInscriptionByUser = Request.register({
    endpoint: '/inscriptions/byUserId/:userId',
    method: 'get',
    useAuthentication: true
})

export const addInscription = Request.register({
    endpoint: '/inscriptions',
    method: 'post',
    useAuthentication: true
})

export const lectureComplete = Request.register({
    endpoint: '/inscriptions/:id/completeLecture',
    method: 'post',
    useAuthentication: true
})


export const checkExam = Request.register({
    endpoint: '/inscriptions/:id/checkExam',
    method: 'post',
    useAuthentication: true
})




// WEBPACK FOOTER //
// ./src/requests/inscriptions.js